module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BLOOD VINES")]), _vm._v(". Copyright © 2010 by Erica Spindler. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_vm._v("Spindler, Erica, 1957–")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paraa"
  }, [_vm._v("Blood vines / Erica Spindler. — 1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paraa"
  }, [_vm._v("        p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paraa"
  }, [_vm._v("ISBN 978-0-312-36392-5")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paraa"
  }, [_vm._v("1. Single women—Fiction. 2. Brothers—Crimes against—Fiction. 3. Human sacrifice—Fiction. 4. Vintners—California—Sonoma Valley—Fiction. 5. Sonoma County (Calif.)—Fiction. 6. Domestic fiction. 7. Identity (Psychology)—Fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_vm._v("I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paraa"
  }, [_vm._v("PS3569.P5436B58 2010")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paraa"
  }, [_vm._v("813'.54—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right-paraa"
  }, [_vm._v("2009040234")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_vm._v("First Edition: March 2010")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraa"
  }, [_vm._v("10   9   8   7   6   5   4   3   2   1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0